import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ShineIcon from 'icons/Shine.icon';
import { CONTACT_US_ROUTE } from 'data/global';

import './WhitelabelingBanner.styles.scss';
import './WhitelabelingBanner.styles.responsive.scss';

type WhitelabelingBannerProps = {
  className?: string;
};

const WhitelabelingBanner: React.FC<WhitelabelingBannerProps> = (props) => {
  const { className } = props;
  const { t } = useTranslation();

  const classes = classNames('whitelabeling-banner', className);

  return (
    <div className={classes}>
      <ShineIcon />
      <div>
        <span>{t('newwl')}</span> {t('whitelabelingBannerText')}{' '}
        <Link to={CONTACT_US_ROUTE}>{t('contactUsToday')}</Link>
      </div>
    </div>
  );
};

export default WhitelabelingBanner;
